import { Location } from 'history';
import {
  PROGRAMMING_BUILDING_VIEWS,
  SCENARIO_LIST_TYPES,
} from 'spw-components/project-details-tabs/building-details/constants';
import { getListTypeByScenario } from 'spw-components/programming-scenarios/building-hs-sc-scenario/utils';
import { IFloor } from 'spw-redux/modules/projects/types';
import { PlainProgramScenario } from '../../../models/Scenario';

export const getScenarioListType = (
  location: Location,
  scenario: PlainProgramScenario
) => {
  const urlSearchParams = new URLSearchParams(location.search);
  const type = urlSearchParams.get('type');

  if (!type && scenario) {
    const views = [
      PROGRAMMING_BUILDING_VIEWS.SCENARIO_DETAILS,
      PROGRAMMING_BUILDING_VIEWS.TOTAL_PROGRAM_DETAILS,
      `${PROGRAMMING_BUILDING_VIEWS.SCENARIO_SUMMARY}/scenarios/${scenario.id}`,
    ];
    if (views.some((view) => location.pathname.includes(view))) {
      return getListTypeByScenario(scenario);
    }
  }

  return type;
};

export const buildSearchParams = (
  scenarioListType: string,
  urlSearchParams: URLSearchParams,
  floor: IFloor
) => {
  return scenarioListType === SCENARIO_LIST_TYPES.FLOOR
    ? `type=${scenarioListType}&floor_id=${
        urlSearchParams.get('floor_id') || floor?.id
      }`
    : `type=${scenarioListType || 'macro'}`;
};
